import React, { Component,Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm, change,
	formValueSelector } from 'redux-form'
import { DefaultPlayer as Video } from 'react-html5video'
import map from 'async/map'
import isEmpty from 'lodash/isEmpty'
import bindAll from 'lodash/bindAll'
import Promise from 'bluebird'
import $ from 'jquery'
import snakeCase from 'voca/snake_case'
import UAParser from 'ua-parser-js'
import imgDefaultLogo from '../../../images/public/company_empty.png'
import imgSubmitted from '../../../images/submitted.svg'
import imgAppStore from '../../../images/public/appstore.png'
import imgGooglePlay from '../../../images/public/googleplay.png'
import imgAstrntFooter from '../../../images/public/logo-astronaut.svg'
import ProgressBarAngga from '../../partials/ProgressBarAngga'
import validate from './validate'
import { List, Map, OrderedMap, fromJS } from 'immutable'
// import Swal from 'sweetalert2'
import _axios from '../../../dependencies/_axios'
import SweetAlert from 'sweetalert-react'
// import { EmailShareButton, FacebookShareButton, TwitterShareButton, LinkedinShareButton, WhatsappShareButton } from 'react-share'
import moment from 'moment'
import {
	publicJobGetDetail,
	registrationSaveData,
	publicJobGetDetailAsync,
	registrationSaveDataError
} from '../../../actions/public/companies'


import {
    t,
    globalGenerateUnitOfTimeHelper
} from '../../../helpers/global'

import {
	globalHideSweetAlert,
	globalAddSweetAlertData
} from '../../../actions/global'

require('es6-promise').polyfill()

export const fields = ['file']

type State = {
  isConsent: boolean,
  isSaved: boolean
};

const renderTime = (job)=> {
	return job.timezone ? job.timezone.suffix : '(GMT+7)'
}

class CompanyJobDetailMobile extends Component {
	constructor(props) {
		super(props)

		this.state = {
			file: '',
			experience: '0',
			name: '',
			email: '',
			code: '',
			url: '',
			isConsent: false,
			isSaved: false,
			uploadFilePercentage:'',
			testColor:'#564FDB',
			uploadProgress:'',
			cvName:'',
		}

	
	}


	componentDidMount(){
		const { publicJobDetail,publicJobGetDetail } = this.props
		
		publicJobGetDetail(this.props.companySlug, this.props.jobSlugs)
	
		// const company = JSON.parse(document.querySelector('#js-public-index-component').dataset.company)
		
		var timesRun=0
		
		this.setState({ name: '', email: '', code: '' })
		
		var interval=setInterval(() => {
			 timesRun += 1;
			if(timesRun === 100){
        clearInterval(interval);
   		 }

				$('li').each(function() {
						var $this = $(this);
					if($this.attr('style')){
						// console.log($(this).attr('style'));
						// $this.parent().addClass("class-new");
					}else{
						$this.attr("style", "list-style-position:outside")
					}
				});
			
      $('.rh5v-Overlay_inner').css('background-color', this.props.publicJobCustom.color)
    }, 100);
		
	
		

	}


 createMarkup(message) {
		return {__html: message};
	}

	render() {
		const {
			publicJobDetail,
			handleSubmit,
			submitting,
			pristine,
			errors,
			globalAddSweetAlertData,
			error_email_exists,
			globalSweetAlertData,
			formValues,
			publicJobCustom
		} = this.props
		
		const thisPageURL = window.location.href
		const company = publicJobDetail.company || {}
		const customColor = publicJobCustom.color
		const backgroundImage = publicJobCustom.backgroundImage
		const socialMedia = publicJobCustom.social_media
		
		const job = publicJobDetail.job || {}
		const dueDate = moment(job.due_date).format("DD MMM YYYY")
		const additionalField = publicJobDetail.additionalField || []
		const gdpr_text = publicJobDetail.gdpr_text || []
		const gdpr_agreement_text = publicJobDetail.gdpr_aggrement_text || []
		const job_document_type = job.document_type == 'CV' ? 'Curriculum Vitae' : 'Company Investment Profile'
		const job_video_url = publicJobDetail.job ? publicJobDetail.job.introduction_video.job_video_url : ''
		const show_due_date = publicJobDetail.show_due_date==null?1:publicJobDetail.show_due_date
		console.log(publicJobDetail.show_due_date)
		console.log(show_due_date)
		console.log(job)
		return(
			<div>
				<header className="header-career-mobile">
					<div className="container">
						<div className="header-detail vertical-item--center flex-between float-align-right text-right" style={{padding:"16px"}}>
							<div>
								<h3 className="heading3 m-b-5">{job.title}</h3>
								
								<p className="font-16">{!isEmpty(job.jobType) ? <span>{job.jobType}</span>: '' }{!isEmpty(job.due_date) ? <span className="m-l-10">{show_due_date==1?<Fragment>&bull;&nbsp;&nbsp;{`Due Date`}</Fragment>:''} <b>{show_due_date==1?dueDate:''} {show_due_date?renderTime(job):''}</b></span>: '' }</p>
							</div>
						</div>
					</div>
				</header>
				<section className="p-b-24 bg-ios" id="registration-form">
					<div className="container">
						<div className="row">
							<div className="col-sm-12 col-md-12 p-l-15 p-r-15">
								<div>
									<section className="section-desc">
										<div><label className="label-desc-mobile">DESCRIPTION</label></div>
										<div className="div-wisiwig" dangerouslySetInnerHTML={this.createMarkup(job.aboutDescription)}  />
									</section>
								</div>
								{job.responsibility != 'null' || job.responsibility.trim() == ''  || typeof job.responsibility == 'null' ?
									null
								: 
								<div className="m-t-30">
									<section className="section-desc">
										<div><label className="label-desc-mobile">RESPONSIBILITY</label></div>
										<div><p className="p-desc-mobile">{job.responsibility}</p></div>
									</section>
								</div>
								 }

								{job.requirement != 'null' || job.requirement.trim() =='' || typeof job.requirement == 'null' ?
								null
								: <div className="m-t-30">
									<section className="section-desc">
										<div><label className="label-desc-mobile">REQUIREMENT</label></div>
										<div><p className="p-desc-mobile">{job.requirement}</p></div>
									</section>
								</div> }
							</div>
						</div>
					</div>
				</section>
			</div>
		)
	}
}

CompanyJobDetailMobile.propTypes = {
	errors: PropTypes.object,
	publicJobGetDetail: PropTypes.func.isRequired,
	companySlug: PropTypes.string,
	jobSlugs: PropTypes.string,
	registrationSaveData: PropTypes.func.isRequired,
	publicJobDetail: PropTypes.object.isRequired,
	fields: PropTypes.array.isRequired,
	publicJobGetDetailAsync: PropTypes.func.isRequired,
}

const mapStateToProps = (state, ownProps) => {
	const publicJobDetail = state.publicJobDetail.toJS()
	const company = publicJobDetail.company || {}
	const job = publicJobDetail.job || {}

	const initialValues = {
		company_id: company.id,
		job_id: job.id,
		interview_code: job.open_code,
		cv:'',
		experience:'',
	}
  return {
		publicJobDetail: state.publicJobDetail.toJS(),
		translationjob: state.publicJobDetail.toJS(),
		errors: state.registrationSaveDataError.toJS(),
		publicJobCustom: state.publicJobCustom.toJS(),
		error_email_exists: state.registrationEmailDuplicate,
		companySlug: ownProps.match.params.companySlug,
		jobSlugs: ownProps.match.params.jobSlugs,
		globalSweetAlertData: state.globalSweetAlertData.toJS(),
		initialValues,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
		changeFieldValue: (field, value) => dispatch(change('CompanyJobDetailMobile', field, value, true, true)),
		globalHideSweetAlert: () => dispatch(globalHideSweetAlert()),
		globalAddSweetAlertData: (options) => dispatch(globalAddSweetAlertData(options)),
		registrationSaveData: (companySlug, jobSlugs, values) => dispatch(registrationSaveData(companySlug, jobSlugs, values)),
		publicJobGetDetail: (companySlug, jobSlugs) => dispatch(publicJobGetDetail(companySlug, jobSlugs)),
		publicJobGetDetailAsync: (publicJobDetail) => dispatch(publicJobGetDetailAsync(publicJobDetail)),
		globalAddSweetAlertData:(option)=>dispatch(globalAddSweetAlertData(option)),
		globalHideSweetAlert:()=>dispatch(globalHideSweetAlert()),
		registrationSaveDataError:(error)=>dispatch(registrationSaveDataError(error)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyJobDetailMobile)
